import { useEffect, useState } from 'react'

import Product from '../../../domains/Product'
import { shouldShowTruefitWidget } from '../true-fit.helpers'

// https://lastbrand.atlassian.net/browse/SFPLTFRM-259 - Ticket to remove truefit properly
// For now we will disbale it using config

const IS_TRUEFIT_ENABLED = false

function useTrueFitWidgetVisibility(product: Product | undefined): {
  showTruefitWidget: boolean
} {
  const [showTruefitWidget, setShowTrueFitWidget] = useState(false)

  useEffect(() => {
    if (!IS_TRUEFIT_ENABLED) setShowTrueFitWidget(false)
    else {
      const canShowTruefitWidget = shouldShowTruefitWidget(product)
      setShowTrueFitWidget(canShowTruefitWidget)
    }
  }, [product])

  return {
    showTruefitWidget,
  }
}

export default useTrueFitWidgetVisibility
